export default __webpack_public_path__ + "img/NOMA_BF.0ec658b504ebbd782dc50840f9a5453c.jpg";